import React, { useEffect, useState } from "react";
import "./AnalyticsPage.scss";
// Для графиков (если захочешь)
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import api from "../api/axios";

export default function AnalyticsPage() {
    const [stats, setStats] = useState({
        totalCompanies: 0,
        noPlaylist: 0,
        onlineDevices: 0,
    });
    const [activityChart, setActivityChart] = useState([]);
    const [playlistChart, setPlaylistChart] = useState([]);
    const [lastActivities, setLastActivities] = useState([]);
    const [withoutPlaylist, setWithoutPlaylist] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get("/admin/analytics")
            .then(({ data }) => {
                setStats({
                    totalCompanies: data.totalCompanies || 0,
                    noPlaylist: data.noPlaylist || 0,
                    onlineDevices: data.onlineDevices || 0,
                });
                setActivityChart(data.activityChart || []);
                setPlaylistChart(data.playlistChart || []);
                setLastActivities(data.lastActivities || []);
                setWithoutPlaylist(data.withoutPlaylist || []);
            })
            .catch(() => {
                // Если нет ответа, показывай заглушки
                setStats({ totalCompanies: 0, noPlaylist: 0, onlineDevices: 0 });
                setActivityChart([]);
                setPlaylistChart([]);
                setLastActivities([]);
                setWithoutPlaylist([]);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="analytics-page">
            <div className="analytics-header">
                <h2>Аналитика</h2>
            </div>

            <div className="analytics-cards">
                <div className="analytics-card">
                    <div className="analytics-label">Всего компаний</div>
                    <div className="analytics-value">{stats.totalCompanies}</div>
                </div>
                <div className="analytics-card danger">
                    <div className="analytics-label">Без плейлиста</div>
                    <div className="analytics-value">{stats.noPlaylist}</div>
                </div>
                <div className="analytics-card success">
                    <div className="analytics-label">Онлайн устройств</div>
                    <div className="analytics-value">{stats.onlineDevices}</div>
                </div>
            </div>

            {/*<div className="analytics-charts-row">*/}
            {/*    <div className="analytics-chart-block">*/}
            {/*        <h4>Активность устройств</h4>*/}
            {/*        <div className="analytics-chart">*/}
            {/*            /!**/}
            {/*            <ResponsiveContainer width="100%" height={220}>*/}
            {/*                <BarChart data={activityChart}>*/}
            {/*                    <XAxis dataKey="date" />*/}
            {/*                    <YAxis allowDecimals={false} />*/}
            {/*                    <Tooltip />*/}
            {/*                    <Bar dataKey="value" fill="#2c60e7" />*/}
            {/*                </BarChart>*/}
            {/*            </ResponsiveContainer>*/}
            {/*            *!/*/}
            {/*            <div style={{ color: "#b2b2b2", textAlign: "center", marginTop: 75 }}>*/}
            {/*                [График будет здесь]*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="analytics-chart-block">*/}
            {/*        <h4>Топ плейлистов</h4>*/}
            {/*        <div className="analytics-chart">*/}
            {/*            /!**/}
            {/*            <ResponsiveContainer width="100%" height={220}>*/}
            {/*                <BarChart data={playlistChart}>*/}
            {/*                    <XAxis dataKey="playlist" />*/}
            {/*                    <YAxis allowDecimals={false} />*/}
            {/*                    <Tooltip />*/}
            {/*                    <Bar dataKey="count" fill="#56b280" />*/}
            {/*                </BarChart>*/}
            {/*            </ResponsiveContainer>*/}
            {/*            *!/*/}
            {/*            <div style={{ color: "#b2b2b2", textAlign: "center", marginTop: 75 }}>*/}
            {/*                [График будет здесь]*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="analytics-tables-row">
                <div className="analytics-table-block">
                    <h4>Последние активности</h4>
                    <table>
                        <thead>
                        <tr>
                            <th>Компания</th>
                            <th>Дата</th>
                        </tr>
                        </thead>
                        <tbody>
                        {lastActivities.length === 0 ? (
                            <tr>
                                <td colSpan={2} style={{ color: "#b4b9cc", textAlign: "center" }}>
                                    Нет данных
                                </td>
                            </tr>
                        ) : (
                            lastActivities.map((item, i) => (
                                <tr key={i}>
                                    <td>{item.company}</td>
                                    <td>{item.date}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>
                <div className="analytics-table-block">
                    <h4>Компании без плейлиста</h4>
                    <table>
                        <thead>
                        <tr>
                            <th>Компания</th>
                            <th>Адрес</th>
                        </tr>
                        </thead>
                        <tbody>
                        {withoutPlaylist.length === 0 ? (
                            <tr>
                                <td colSpan={2} style={{ color: "#b4b9cc", textAlign: "center" }}>
                                    Все компании с плейлистом
                                </td>
                            </tr>
                        ) : (
                            withoutPlaylist.map((item, i) => (
                                <tr key={i}>
                                    <td>{item.company}</td>
                                    <td>{item.address}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>
            </div>

            {loading && <div className="analytics-loading">Загрузка...</div>}
        </div>
    );
}
